import { render, staticRenderFns } from "./DeletedModels.vue?vue&type=template&id=2cb5fb72&scoped=true"
import script from "./DeletedModels.vue?vue&type=script&lang=js"
export * from "./DeletedModels.vue?vue&type=script&lang=js"
import style0 from "./DeletedModels.vue?vue&type=style&index=0&id=2cb5fb72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5fb72",
  null
  
)

export default component.exports